export default __webpack_public_path__ + "static/icon-29-3-78219b4e5e85545ac9f450342181a399.png";